import { formatBookingTime, formatEuroCents } from '../lib/format';
import type { ZuruecknehmbareBuchung } from './types';

interface Props {
  /** Wessen Buchungen -- der Name steht im Satz, nicht nur oben in der Leiste. */
  name: string;
  buchungen: ZuruecknehmbareBuchung[];
  disabled?: boolean;
  onZuruecknehmen: (sk: string) => void;
}

/**
 * 2026-10-02 (Owner-Fund): Was am Monatsevent an die Stelle des Korrektur-Schalters tritt.
 *
 * Owner: *„Ein Mitglied hat über die Korrekturfunktion Getränke korrigiert, die er vorher gar nicht
 * gebucht hatte. […] Heißt meines Erachtens wir müssen die Korrektur durch ein Rückgängig
 * ersetzen."*
 *
 * **Der Unterschied zur Korrekturbuchung ist der ganze Punkt:** Jede Zeile hier ZEIGT auf eine
 * Buchung, die es gibt. Erfinden kann sie nichts -- und damit kann aus einem Fehlgriff keine
 * Inventurdifferenz mehr werden, die nach Schwund aussieht.
 *
 * Eigene Komponente, nicht nur ein Block in `KioskScreen`: Der Bildschirm ist über 700 Zeilen lang,
 * und CSS ist in jsdom nicht beobachtbar (Lehre vom 31.08.) -- so lässt sich die Liste mit dem
 * echten Stylesheet in echter Größe ansehen, statt sie für eine Probe nachzubauen. Eine Probe, die
 * das Ergebnis anders anordnet als die Wirklichkeit, ist keine (Lehre vom 28.09.).
 */
export default function UndoList({ name, buchungen, disabled, onZuruecknehmen }: Props) {
  if (buchungen.length === 0) return null;
  return (
    <div className="kiosk-undo-list">
      <h2>Falsch gebucht?</h2>
      <p className="kiosk-undo-list-hint">
        Diese Buchungen für {name} lassen sich noch stornieren — 15 Minuten lang, auch wenn sie an
        einem anderen Gerät erfasst wurden.
      </p>
      <ul>
        {buchungen.map((b) => (
          <li key={b.sk}>
            <span className="kiosk-undo-list-main">
              {b.quantity}× {b.beverageName}
            </span>
            <span className="kiosk-undo-list-sum">{formatEuroCents(b.sumCents)}</span>
            <span className="kiosk-undo-list-time">{formatBookingTime(b.createdAt)}</span>
            <button disabled={disabled} onClick={() => onZuruecknehmen(b.sk)}>
              Storno
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
